const userApplicationsPermissions = (state = {}, action) => {
  Object.freeze(state);
  switch (action.type) {
    case 'SET_USER_APPLICATIONS_PERMISSIONS':
      const {
        userApplications
      } = action;
      const userApplicationsPermissionsObject = {};
      userApplications.forEach(userApplication => {
        const { appId, permissions } = userApplication;
        if(permissions) userApplicationsPermissionsObject[appId] = permissions;
      });

      return userApplicationsPermissionsObject;
    case 'UPDATE_USER_APPLICATIONS_PERMISSIONS':
      return {
        ...state,
        [action.appId]: action.permissionIds
      }
    case 'UNSET_USER_APPLICATIONS_PERMISSIONS':
      return {};
    default:
      return state;
  }
};

export default userApplicationsPermissions;